const ReviewStatus = {
    REVIEW_CREATED: "Review Created",
    IN_PROGRESS: "In Progress",
    READY_FOR_CONSENSUS: "Ready for Consensus",
    CONSENSUS_IN_PROGRESS: "Consensus in Progress",
    CLOSED: "Closed",
    DELETED: "Deleted"
};

export default ReviewStatus;